import type { CityConfig } from "@/pages/city-template/types";

export const glensFallsConfig: CityConfig = {
  city: "Glens Falls",
  state: "New York",
  stateAbbr: "NY",
  slug: "glens-falls",
  route: "/cities/glens-falls",
  title: "Emergency & Expedited Passport Glens Falls NY | Same Day Passport Glens Falls",
  metaDescription:
    "Emergency passport Glens Falls NY — same day, 24-hour, and 3-5 day expedited passport processing for Warren County. Fast Passport Center serves Glens Falls, Queensbury, Hudson Falls, and all Adirondack gateway communities.",
  h1: "Emergency & Expedited Passport Services in Glens Falls, NY",
  heroSubtitle:
    "Glens Falls' fast passport solution — the Gateway to the Adirondacks. Whether you're flying out of Albany International or Saratoga County Airport, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Glens%20Falls%20New%20York%20downtown%20with%20historic%20buildings%2C%20Hudson%20River%20flowing%20through%20the%20city%2C%20green%20Adirondack%20mountains%20in%20background%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20upstate%20New%20York%20gateway%20city%20with%20river%20and%20mountain%20backdrop&width=1600&height=700&seq=ny-glens-falls-hero-001&orientation=landscape",
  heroImageAlt: "Glens Falls New York downtown with Hudson River and Adirondack Mountains",
  geoPosition: "43.3095; -73.6440",
  geoPlacename: "Glens Falls, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~200 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Glens Falls", zips: "12801" },
    { name: "Queensbury", zips: "12804" },
    { name: "Hudson Falls", zips: "12839" },
    { name: "South Glens Falls", zips: "12803" },
    { name: "Lake George", zips: "12845" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Ballston Spa", zips: "12020" },
    { name: "Malta", zips: "12020" },
    { name: "Clifton Park", zips: "12065" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Lake Placid", zips: "12946" },
    { name: "Saranac Lake", zips: "12983" },
    { name: "Ticonderoga", zips: "12883" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Glens Falls travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Glens Falls residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Warren & Adirondack Gateway Region",
      desc: "Glens Falls, Queensbury, Lake George, and the Adirondack gateway — we serve all of the region from the Hudson to the mountains.",
    },
  ],
  testimonials: [
    {
      name: "Karen D.",
      location: "Queensbury, NY",
      rating: 5,
      text: "Had a family emergency overseas and needed my passport renewed fast. Fast Passport Center delivered in 3 days from right here in Queensbury. Truly lifesaving service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark H.",
      location: "Glens Falls, NY",
      rating: 5,
      text: "Renewed my passport for a summer trip to Lake George and then Montreal. The 5-day service was exactly what I needed. Fast and professional.",
      service: "Passport Renewal",
    },
    {
      name: "Amy S.",
      location: "Lake George, NY",
      rating: 5,
      text: "First-time passport for our family cruise. The agent helped us through the Glens Falls post office process. Everything went smoothly and arrived in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "glens-falls-1",
      name: "Glens Falls Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "16 Hudson Avenue",
      city: "Glens Falls",
      state: "NY",
      zip: "12801",
      phone: "518-793-2634",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Glens Falls",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Glens Falls passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "glens-falls-2",
      name: "Queensbury Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "553 Aviation Road",
      city: "Queensbury",
      state: "NY",
      zip: "12804",
      phone: "518-793-6198",
      hours: "Mon-Fri 9:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Queensbury (north of Glens Falls)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Queensbury and North Country residents near Lake George.",
      icon: "ri-building-2-line",
    },
    {
      id: "glens-falls-3",
      name: "Hudson Falls Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "115 Main Street",
      city: "Hudson Falls",
      state: "NY",
      zip: "12839",
      phone: "518-747-3871",
      hours: "Mon-Fri 9:00 AM - 4:00 PM",
      distance: "Hudson Falls (east of Glens Falls)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Hudson Falls, Fort Edward, and eastern Washington County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Glens Falls?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Glens Falls residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Glens Falls?",
      a: "The Glens Falls Main Post Office at 16 Hudson Avenue is the major Glens Falls passport acceptance facility. The Queensbury Post Office at 553 Aviation Road and Hudson Falls Post Office at 115 Main Street are also convenient options for Warren County and Washington County residents.",
    },
    {
      q: "Can I get same-day passport photos in Glens Falls?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and Rite Aid locations throughout Glens Falls, Queensbury, and Lake George. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Glens Falls?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Glens Falls passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Glens Falls?",
      a: "The fastest way to renew a passport in Glens Falls is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Glens Falls?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Glens Falls and all Warren County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Glens Falls?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Glens Falls. We serve the Adirondack gateway region and all of Warren County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Glens Falls", address: "various CVS locations across Glens Falls, Queensbury, and Lake George", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Glens Falls", address: "various Walgreens locations throughout Glens Falls and Queensbury", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Glens Falls", address: "various Rite Aid locations in Glens Falls and Hudson Falls", hours: "Mon-Sun, hours vary by location" },
    { name: "Walmart Photo Center — Queensbury", address: "Walmart Supercenter, Queensbury", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Queensbury",
      address: "579 Aviation Road, Queensbury, NY 12804",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Queensbury DMV office for license renewals and REAL ID applications. Serves Glens Falls, Queensbury, and Lake George area.",
      featured: true,
    },
    {
      name: "NYS DMV — Hudson Falls",
      address: "3839 Burgoyne Avenue, Hudson Falls, NY 12839",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Hudson Falls DMV office serving eastern Warren County and Washington County residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Saratoga Springs",
      address: "6 Franklin Square, Saratoga Springs, NY 12866",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Saratoga Springs DMV office serving southern Warren County and northern Saratoga County.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~55 miles from Glens Falls",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "The closest major airport to Glens Falls with flights to destinations nationwide and international connections. Most convenient for Adirondack gateway travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "5B2",
      name: "Floyd Bennett Memorial Airport (Glens Falls)",
      distance: "In Queensbury, NY",
      address: "443 Queensbury Avenue, Queensbury, NY 12804",
      note: "General aviation airport serving Glens Falls and the Adirondack region. For private and charter flights.",
      flightUrl: "https://www.glensfallsairport.com/",
      flightLabel: "Glens Falls Airport",
      featured: false,
    },
    {
      code: "KGFL",
      name: "Saratoga County Airport",
      distance: "~25 miles from Glens Falls",
      address: "21 West Milton Road, Ballston Spa, NY 12020",
      note: "General aviation airport serving Saratoga County and the Capital Region. For private and charter flights.",
      flightUrl: "https://www.saratogacountyairport.com/",
      flightLabel: "Saratoga Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Glens Falls travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Glens Falls residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Glens Falls residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Glens Falls residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Glens Falls, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Glens Falls residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Glens Falls travelers with immediate departure needs from Albany International or Glens Falls Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Glens Falls residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Glens Falls residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Glens Falls residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Glens Falls and Warren County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Glens Falls." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Glens Falls travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Glens Falls travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Glens Falls team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Glens Falls address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Ballston Spa", route: "/cities/ballston-spa" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Malone", route: "/cities/malone" },
    { name: "Tupper Lake", route: "/cities/tupper-lake" },
    { name: "Lake George", route: "/cities/lake-george" },
    { name: "Ballston Spa", route: "/cities/ballston-spa" },
    { name: "Gloversville", route: "/cities/gloversville" },
    { name: "Rome", route: "/cities/rome-ny" },
    { name: "Amsterdam", route: "/cities/amsterdam-ny" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Glens Falls and the Adirondack gateway region as a remote courier service. We do not have a physical office in Glens Falls, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Glens Falls area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Glens Falls and all of Warren County. From the Hudson River to the Adirondacks, from Queensbury to Lake George — we serve the gateway to the North Country with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Glens Falls and all surrounding communities across Warren County and the Adirondack gateway region. Whether you're in Queensbury, Hudson Falls, or Lake George, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Glens Falls customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Glens Falls travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Glens Falls travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Glens Falls. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default glensFallsConfig;